import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ProofMetadata = ({ submissionDate, starRating, description, youtubeUrl }) => {
  const [copied, setCopied] = useState(false);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('ko-KR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
    });
  };

  const handleCopyUrl = async () => {
    const url = String(youtubeUrl || '').trim();
    if (!url) return;
    
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy URL:', err);
    }
  };

  return (
    <div className="space-y-4 md:space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-primary/20 rounded-md flex items-center justify-center">
            <Icon name="Calendar" size={20} color="var(--color-primary)" />
          </div>
          <div>
            <div className="text-xs text-muted-foreground caption">제출 날짜</div>
            <div className="text-sm font-medium text-foreground">{formatDate(submissionDate)}</div>
          </div>
        </div>

        <div className="flex items-center space-x-2 px-3 py-2 rounded-md bg-primary/20 border border-primary/30">
          {[...Array(5)]?.map((_, index) => (
            <Icon
              key={index}
              name="Star"
              size={20}
              color="currentColor"
              className={index < starRating ? 'fill-current text-primary' : 'text-muted-foreground'}
            />
          ))}
          <span className="text-sm font-medium text-foreground data-text ml-2">
            {starRating}/5
          </span>
        </div>
      </div>
      {description && (
        <div className="p-4 md:p-6 bg-muted/50 rounded-lg">
          <div className="flex items-start space-x-3 mb-3">
            <div className="flex-shrink-0 w-8 h-8 bg-primary/20 rounded-md flex items-center justify-center">
              <Icon name="FileText" size={16} color="var(--color-primary)" />
            </div>
            <h3 className="text-sm font-heading font-semibold text-foreground">증명 설명</h3>
          </div>
          <p className="text-sm text-foreground leading-relaxed whitespace-pre-wrap pl-11">
            {description}
          </p>
        </div>
      )}

      {String(youtubeUrl || '').trim() && (
        <div className="p-4 md:p-6 bg-muted/50 rounded-lg">
          <div className="flex items-start space-x-3 mb-3">
            <div className="flex-shrink-0 w-8 h-8 bg-destructive/10 rounded-md flex items-center justify-center">
              <Icon name="PlayCircle" size={16} color="var(--color-destructive)" />
            </div>
            <h3 className="text-sm font-heading font-semibold text-foreground">유튜브</h3>
          </div>
          <div className="ml-11 space-y-3">
            <div className="p-3 bg-background rounded-md border border-border">
              <div className="text-xs text-muted-foreground caption mb-1">URL</div>
              <div className="text-sm text-foreground break-all font-mono">
                {String(youtubeUrl || '').trim()}
              </div>
            </div>
            <div className="flex items-center gap-2">
              <a
                href={String(youtubeUrl || '').trim()}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-background border border-border hover:bg-muted transition-gaming text-sm font-medium"
              >
                <Icon name="ExternalLink" size={16} />
                유튜브 열기
              </a>
              <button
                onClick={handleCopyUrl}
                className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-background border border-border hover:bg-muted transition-gaming text-sm font-medium"
              >
                <Icon name={copied ? "Check" : "Copy"} size={16} />
                {copied ? "복사됨" : "URL 복사"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProofMetadata;